import { render, staticRenderFns } from "./MtipytamequipamientoFormHeader.vue?vue&type=template&id=4b82de76"
import script from "./MtipytamequipamientoFormHeader.vue?vue&type=script&lang=js"
export * from "./MtipytamequipamientoFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports